export const getCounterWidth = (count: number, responsive?: boolean) => {
  // 11 - estimated letter width in pixels, 80 - sum of button widths and horizontal padding
  return responsive ? `${Math.min(count.toString().length * 11 + 80, 200)}px` : '100%';
};
